import React, { Component } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import {
  selectors as ThreadsSelectors,
  record as ThreadsRecord,
} from 'data/threads'
import {
  getCurrentNoteThreadsNotificationsCount,
  getThreadNotifications,
} from 'data/notifications/selectors'

import ThreadResolver from '../../Thread/ThreadResolver'
import * as Icons from 'components/Utils/Icons'
import ExitButton from '../ExitButton'

class ThreadHeader extends Component {
  static propTypes = {
    thread: PropTypes.instanceOf(ThreadsRecord),
    goToMainPanelView: PropTypes.func.isRequired,
  }

  onCloseThread = () => {
    this.props.setDisplayClosedThreadBanner(true)
    this.props.goToMainPanelView()
  }

  render() {
    const {
      thread,
      totalNotificationsCount,
      currentThreadNotifications,
    } = this.props
    const otherCommentsNotificationCount =
      totalNotificationsCount - currentThreadNotifications.size

    return (
      <div className="padding-horizontal-large">
        <div
          className={classNames(
            'flexbox flexbox-align-center',
            'width-full',
            'border-bottom-medium',
            this.props.scrolling ? 'border-shade-50' : 'border-transparent'
          )}
          style={{ height: 60 }}
        >
          <div
            className="flexbox flexbox-align-center pointer font-weight-medium shade-20 shade-10-on-hover font-size-large"
            onClick={this.props.goToMainPanelView}
          >
            <Icons.LeftThinChevronIcon size={12} />
            {otherCommentsNotificationCount > 0 && (
              <div
                className="flexbox flexbox-centered shade-100-important bold radius-round center-text background-red margin-left-normal"
                style={{ width: 22, height: 22 }}
              >
                {otherCommentsNotificationCount}
              </div>
            )}
            <div className="margin-left-normal">Back to all threads</div>
          </div>
          <div className="margin-left-auto flexbox flexbox-align-center">
            <ThreadResolver
              onCloseThread={this.onCloseThread}
              thread={thread}
              className="flexbox flexbox-align-center margin-left-auto margin-right-medium pointer"
            >
              <div className="font-weight-medium shade-20 shade-10-on-hover font-size-large">
                {thread.resolvedAt ? 'Reopen thread' : 'Resolve'}
              </div>
            </ThreadResolver>
            <ExitButton />
          </div>
        </div>
      </div>
    )
  }
}

export default connect((state, { threadId }) => ({
  totalNotificationsCount: getCurrentNoteThreadsNotificationsCount(state),
  currentThreadNotifications: getThreadNotifications(state)(threadId),
  thread: ThreadsSelectors.getThread(state, threadId),
}))(ThreadHeader)
